import { PostosMaster } from './postos-master.model';
import { UsuarioMaster } from './usuario-master.model';

/**
 * Model representing an Admin Network Post entity
 */
export class AdmRedePosto {
  private _expandidoUsuarios: boolean = false;
  private _expandidoPostos: boolean = false;

  constructor(
    public readonly dscLoginEntidade: string,
    public readonly idAdmRedePosto: string,
    public readonly codEntidade: number,
    public readonly nome: string,
    public usuarios?: UsuarioMaster[],
    public postos?: PostosMaster[],
    public qtdUsuarios?: number,
    public qtdPostos?: number
  ) {}

  static fromJson(json: any): AdmRedePosto {
    return new AdmRedePosto(
      json.dscLoginEntidade || '',
      json.idAdmRedePosto || '',
      json.codEntidade || 0,
      json.nome || '',
      json.usuarios?.map((u: any) => UsuarioMaster.fromJson(u)),
      json.postos?.map((p: any) => PostosMaster.fromJson(p)),
      json.qtdUsuarios,
      json.qtdPostos
    );
  }

  get expandidoUsuarios(): boolean {
    return this._expandidoUsuarios;
  }

  set expandidoUsuarios(value: boolean) {
    this._expandidoUsuarios = value;
    if (value) {
      this._expandidoPostos = false;
    }
  }

  get expandidoPostos(): boolean {
    return this._expandidoPostos;
  }

  set expandidoPostos(value: boolean) {
    this._expandidoPostos = value;
    if (value) {
      this._expandidoUsuarios = false;
    }
  }

  toggleUsuarios(): void {
    this.expandidoUsuarios = !this._expandidoUsuarios;
  }

  togglePostos(): void {
    this.expandidoPostos = !this._expandidoPostos;
  }

  toJson(): any {
    return {
      dscLoginEntidade: this.dscLoginEntidade,
      idAdmRedePosto: this.idAdmRedePosto,
      codEntidade: this.codEntidade,
      nome: this.nome,
      usuarios: this.usuarios?.map((u) => u.toJson()),
      postos: this.postos?.map((p) => p.toJson()),
      qtdUsuarios: this.qtdUsuarios,
      qtdPostos: this.qtdPostos,
    };
  }
}

